import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { addcontext } from '../../ContextShare/ContextShare';
import language from '../../language.json'

function SubtitleDiv({videoData}) {
    const params=useParams()
    const videoIdFromUrl=params.vId
    const [vIdToUrl,setvIdToUrl]=useState()
    const {newIdP,setnewIdP}=useContext(addcontext)
    const {isPartClicked,setisPartClicked}=useContext(addcontext)


    const [whatsappShareUrl, setWhatsappShareUrl] = useState('');
    const [facebookShareUrl, setFacebookShareUrl] = useState('');
    const [currentUrl, setCurrentUrl] = useState('');
    const {langChanged,setlangChanged}=useContext(addcontext)

    const [currentLanguage, setCurrentLanguage] = useState();
  
    useEffect(()=>{
        setCurrentLanguage(localStorage.getItem('language')||'en')
  
  },[currentLanguage,langChanged])
    useEffect(()=>{
        const url = window.location.href;
        setCurrentUrl(url);


        // Sharing URLs
        const newWhatsappShareUrl = `https://wa.me/?text=${encodeURIComponent(url)}`;
        const newFacebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
        setWhatsappShareUrl(newWhatsappShareUrl);
        setFacebookShareUrl(newFacebookShareUrl);
        
      },[vIdToUrl,newIdP,isPartClicked])



   const handleCopyLink = () => {
    if (navigator.clipboard) {
        navigator.clipboard.writeText(videoData?.youtube_link).then(() => {
            toast.success('Link copied to clipboard');
        }).catch(err => {
            toast.error('Failed to copy: ' + err);
        });
    } else {
        toast.error('Clipboard API not supported or disabled in this browser.');
    }
};


    return (
        <div className='flex flex-row h-40 lg:ms-0 ms-5 justify-evenly xl:w-1/5 lg:w-2/5 w-2/5 items-center rounded bg-success' style={{ border: '1px dashed #001F33' }}>
            <div className='flex flex-col w-full gap-2'>

                <a href={videoData?.youtube_link} target='_blank' rel='noopener noreferrer' className='flex flex-row justify-start pl-5 gap-3 items-center hover:bg-blue-gray-100 w-full h-10 cursor-pointer transform duration-500 ease-in-out'>
                <Icon icon="mdi:youtube-tv" className='text-2xl text-red-700' />
                    <p className={`text-red-900 ${currentLanguage=='en'?'text-sm':'text-xs'}`}>{language.View_yt[currentLanguage]}</p>
                </a>

                <div title={currentUrl} onClick={handleCopyLink} className='flex flex-row justify-start pl-5 gap-3 items-center hover:bg-blue-gray-100 cursor-pointer transform duration-500 ease-in-out w-full h-10'>
                    <Icon icon="icon-park-outline:copy-link" className='text-2xl' />
                    <p className={`text-gray-900 ${currentLanguage=='en'?'text-sm':'text-xs'}`}>{language.Copy_Link[currentLanguage]}</p>
                </div>

            </div>
        </div>
    );
}

export default SubtitleDiv;
